document.addEventListener("DOMContentLoaded", function () {
  const images = [...document.querySelectorAll(".parallax")];
  const imageNum = images.length;

  const scale = 1.1;

  const parallaxIntensity = 0.2;

  const divider = 0.0;

  // Use `requestAnimationFrame` for smoother performance
  function updateParallax() {
    for (let i = 0; i < imageNum; i++) {
      // Cache the result of getBoundingClientRect to avoid multiple calls
      const rect = images[i].getBoundingClientRect();
      const transY = rect.top + rect.height / 2 - window.innerHeight / 2;

      // Cache the speed and scale values
      const sp = parseFloat(images[i].getAttribute("data-speed")) || 1;
      const nScale = parseFloat(images[i].getAttribute("data-scale")) || scale;

      // Calculate the new transform value only once
      const transformValue = `translateY(${(
        transY *
        parallaxIntensity *
        -1 *
        sp
      ).toFixed(2)}px) scale(${nScale + divider})`;

      // Apply the transform style
      images[i].style.transform = transformValue;
    }

    // Request the next frame for continuous updates
    requestAnimationFrame(updateParallax);
  }
  if (window.innerWidth > 1100) {
    // Start the animation loop
    updateParallax();
  }

  const easeFactor = 0.1;
  // Mega menu logic
  const megaMenuParents = document.querySelectorAll(".hasMegaMenu");
  const megaMenus = document.querySelectorAll(".megaMenu");
  const header = document.querySelector("header");
  const details = document.querySelector(".details");
  const openDetails = document.querySelector(".headerSummary");
  const searchSVG = document.querySelector(".searchSvgWrapper path");
  const openOverlayNav = document.querySelector(".dropdownNavButton");
  const mobileNav = document.querySelector(".mobileNavigation");
  const mobileDropdowns = Array.from(
    mobileNav.querySelectorAll(".mobileDropdownCellButton")
  );
  const bd = document.body;

  const megaMenusLength = megaMenus.length;

  const SearchPath =
    "M6.54492,1.97266 A4.61914,4.61914 0 1,1 6.54492,11.21094 A4.61914,4.61914 0 1,1 6.54492,1.97266 L9.80957,9.85156 L14.5435,14.5854 L14.5435,14.5854 Z";

  const XPath =
    "M1.58594 1.25 L16.5859 16.2468 M1.58594 16.25 L16.5859 1.25319";

  (function () {
    mobileDropdowns.forEach((button, bIndex) => {
      button.addEventListener("click", (e) => {
        const prnt = button.parentElement;
        prnt.classList.toggle("active");
        const opt = prnt.querySelector(".mobileDropdownList");
        if (opt.style.maxHeight) {
          opt.style.maxHeight = null;
          opt.style.paddingBottom = 0 + "px";
        } else {
          opt.style.maxHeight = opt.scrollHeight + 20 + "px";
          opt.style.paddingBottom = 20 + "px";
        }
      });
    });
  })();

  megaMenuParents.forEach((megaMenu, index) => {
    megaMenu.addEventListener("mouseenter", () => {
      header.classList.add("forceOpen");
      details.classList.remove("open");
      megaMenu.classList.add("hovering");
      openOverlayNav.classList.remove("active");
      mobileNav.classList.remove("active");
      toggleMegaMenuActivity(index);
    });
  });

  openOverlayNav.addEventListener("click", (e) => {
    openOverlayNav.classList.toggle("active");
    mobileNav.classList.toggle("active");
    details.classList.remove("open");
    header.classList.toggle("forceOpen");
    // if (window.innerWidth < 1100) {
    //   bd.classList.toggle("crop");
    // }
    removeMegaMenuActivity();
  });

  header.addEventListener("mouseleave", () => {
    if(!openOverlayNav.classList.contains('active')){
      
    header.classList.remove("forceOpen");
    }
    removeMegaMenuActivity();
  });

  let isMagnifyingGlass = true;

  openDetails.addEventListener("click", (e) => {
    details.classList.toggle("open");
    // const targetPath = isMagnifyingGlass ? XPath : SearchPath;

    // // Animate the `d` attribute
    // searchSVG.setAttribute("d", targetPath);

    // isMagnifyingGlass = !isMagnifyingGlass;
    openOverlayNav.classList.remove("active");
    mobileNav.classList.remove("active");
    removeMegaMenuActivity();
  });

  function swapSvgPath(open = true) {}

  function removeMegaMenuActivity() {
    megaMenus.forEach((megaMenu) => {
      megaMenu.classList.remove("active");
    });
    megaMenuParents.forEach((megaMenu, index) => {
      megaMenu.classList.remove("hovering");
    });
  }
  function toggleMegaMenuActivity(index) {
    for (let i = 0; i < megaMenusLength; i++) {
      if (i === index) {
        megaMenus[i].classList.add("active");
        [...megaMenus[i].children[1].children].forEach((element, index) => {
          const delay = index * easeFactor; // Increase delay for each element
          element.style.transitionDelay = `${delay}s`;
        });
      } else {
        megaMenus[i].classList.remove("active");
        [...megaMenus[i].children[1].children].forEach((element, index) => {
          const delay =
            ([...megaMenus[i].children].length - index - 1) * easeFactor; // Decrease delay for each element
          element.style.transitionDelay = `${delay}s`;
        });
      }
    }
  }

  if (window.innerWidth < 1100) {
    const mobileSublinkParents = document.querySelectorAll(".mobileParentLink");
    const sublinkParentsLength = [...mobileSublinkParents].length;
    const easeFactor = 0.1;

    [...mobileSublinkParents].forEach((parent, ind) => {
      parent.addEventListener("click", (e) => {
        e.preventDefault();
        const sib = parent.parentElement.nextElementSibling;
        if (sib.style.maxHeight) {
          sib.style.maxHeight = null;
          // Ease out
          [...sib.children].forEach((element, index) => {
            const delay = ([...sib.children].length - index - 1) * 0.3; // Decrease delay for each element
            element.style.transitionDelay = `${delay}s`;
          });
        } else {
          sib.style.maxHeight = sib.scrollHeight + "px";
          // Ease in
          [...sib.children].forEach((element, index) => {
            const delay = index * 0.3; // Increase delay for each element
            element.style.transitionDelay = `${delay}s`;
          });
        }
        sib.classList.toggle("extended");

        // for (let i = 0; i < sublinkParentsLength; i++) {
        //   if (i === ind) {
        //     if (sib.style.maxHeight) {
        //       sib.style.maxHeight = null;
        //     } else {
        //       sib.style.maxHeight = sib.scrollHeight + 20 + "px";
        //     }
        //   } else {
        //     sib.style.maxHeight = null;
        //   }
        // }
      });
    });
  }

  window.addEventListener("scroll", handleParallax);
  let lastScroll = 0;
  let scrollDown = false;
  const headerRef = document.querySelector("header");
  function handleParallax(e) {
    const currentWindowScroll = window.scrollY;

    if (
      currentWindowScroll > lastScroll &&
      scrollDown == false &&
      currentWindowScroll > 100
    ) {
      headerRef.classList.add("tucked");
      scrollDown = true;
    } else if (currentWindowScroll < lastScroll && scrollDown == true) {
      headerRef.classList.remove("tucked");
      scrollDown = false;
    }
    lastScroll = currentWindowScroll;
  }

  let blitzThreshold = 0.55;
  if (window.innerWidth < 1100) {
    blitzThreshold = 0.3;
  }

  // Blitz Observer
  const blitzObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const blitzChildren = entry.target.children;
          animateBlitz(blitzChildren);
          observer.unobserve(entry.target); // Stop observing once animated
        }
      });
    },
    { threshold: blitzThreshold }
  );

  function animateBlitz(children) {
    const delay = 0.1;
    const length = 1.0;
    Array.from(children).forEach((child, index) => {
      if (!child.classList.contains("notBlitz")) {
        child.style.transition = `transform ${length}s var(--cEaseInOut) ${
          index * delay
        }s, opacity ${length}s var(--cEaseInOut) ${index * delay}s`;
        child.style.transform = "translate(0, 0)";
        child.style.opacity = "1";
      }
    });
  }

  function initBlitz() {
    document.querySelectorAll(".blitz").forEach((el) => {
      blitzObserver.observe(el);
    });
  }

  initBlitz();

  // Hero Observer
  const heroObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const heroChild = entry.target;
          animateHero(heroChild);
          observer.unobserve(entry.target); // Stop observing once animated
        }
      });
    },
    { threshold: 0.45 }
  );

  function animateHero(child) {
    child.children[0].style.transform = "scale(1.1)";
  }

  function initHero() {
    document.querySelectorAll(".heroObserver").forEach((el) => {
      heroObserver.observe(el);
    });
  }

  initHero();

  // Fade Observer
  const fadeObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const heroChild = entry.target;
          animateFades(heroChild);
          observer.unobserve(entry.target); // Stop observing once animated
        }
      });
    },
    { threshold: 0.9 }
  );

  function animateFades(child) {
    child.style.transform = "translateY(0)";
    child.style.opacity = "1";
  }

  function initFades() {
    document.querySelectorAll(".fadeUp").forEach((el) => {
      fadeObserver.observe(el);
    });
  }

  initFades();

  // End Dom Content Loaded
});
